import Joi from 'joi';

/**
 * Schema for driver eligibility policy config validation
 */
export const driverEligibilityConfigSchema = () =>
	Joi.object({
		minimumAge: Joi.number().min(0).integer().allow(null).optional(),
		maximumAge: Joi.number().min(0).integer().allow(null).optional(),
		drivingExperienceYears: Joi.number().min(0).integer().allow(null).optional(),
		minimumAgeToRent: Joi.number().min(0).integer().allow(null).optional(),
		allowedLicenseCategories: Joi.array()
			.items(Joi.string())
			.allow(null)
			.optional(),
	})
		.unknown(false)
		.custom((value, helpers) => {
			const hasNumericRule =
				value.minimumAge != null ||
				value.maximumAge != null ||
				value.drivingExperienceYears != null ||
				value.minimumAgeToRent != null;

			const hasCategories =
				Array.isArray(value.allowedLicenseCategories) &&
				value.allowedLicenseCategories.length > 0;

			if (!hasNumericRule && !hasCategories) {
				return helpers.error('any.custom', {
					message:
						'Provide at least one driver eligibility rule (age, experience, ' +
						'or allowed license categories)',
				});
			}

			return value;
		});
